<div class="setlist-clock-container">
  <div class="clock-container" #clockPie></div>
  <div class="icon-container">
    <div class="current-slot" [@fadeInOut]
      *ngIf="(showEqualizer$ | async) && (isCurrentDay$ | async) && day !== '24' && (context$ | async) !== 'SCHEDULE_24H'">
      <div class="slot-title">{{ (slotName?.length>12)? (slotName | titlecase | slice:0:12)+'..':(slotName | titlecase)
        }}</div>
      <div class="wave-container">
        <img src="/assets/wave.svg" alt="soundwave1" />
        <img src="/assets/wave.svg" alt="soundwave2" />
      </div>
      <div class="slot-duration">{{ currentSlot$ | async | hourstamp:"startTime" }} > {{ currentSlot$ | async |
        hourstamp:"endTime" }}</div>
    </div>

    <div class="current-slot" [@fadeInOut] *ngIf="(showEqualizer$ | async) && !(isCurrentDay$ | async) && day !== '24'">
      <div class="slot-title"></div>
    </div>

    <div class="current-slot" [@fadeInOut]
      *ngIf="(showEqualizer$ | async) && (isCurrentDay$ | async) && day === '24' && (context$ | async) === 'SCHEDULE_24H'">
      <div class="slot-title">{{ (slotName?.length>12)? (slotName | titlecase | slice:0:12)+'..':(slotName | titlecase)
        }}</div>
      <div class="wave-container">
        <img src="/assets/wave.svg" alt="soundwave1" />
        <img src="/assets/wave.svg" alt="soundwave2" />
      </div>
      <div class="slot-duration">{{ currentSlot$ | async | hourstamp:"startTime" }} > {{ currentSlot$ | async |
        hourstamp:"endTime" }}</div>
    </div>

    <div class="current-slot" [@fadeInOut]
      *ngIf="!(showEqualizer$ | async) && !(isCurrentDay$ | async) && day !== '24' && (context$ | async) !== 'SCHEDULE_24H'">
      <div class="slot-title" *ngIf="nameSlot">{{nameSlot}}</div>
      <div class="slot-duration">{{ currentSlot$ | async | hourstamp:"startTime" }} > {{ currentSlot$ | async |
        hourstamp:"endTime" }}</div>
    </div>

    <div class="current-slot" [@fadeInOut]
      *ngIf="(showEqualizer$ | async) && !(isCurrentDay$ | async) && day !== '24' && (context$ | async) !== 'SCHEDULE_24H'">
      <div class="slot-title" *ngIf="nameSlot">{{nameSlot}}</div>
      <div class="slot-duration">{{ currentSlot$ | async | hourstamp:"startTime" }} > {{ currentSlot$ | async |
        hourstamp:"endTime" }}</div>
    </div>

    <div class="current-slot" [@fadeInOut]
      *ngIf="(showEqualizer$ | async) && day === '24' && (context$ | async) === 'SCHEDULE_24H'">
      <div class="slot-title">{{ (slotName?.length>12)? (slotName | titlecase | slice:0:12)+'..':(slotName | titlecase)
        }} test 1</div>
      <div class="wave-container">
        <img src="/assets/wave.svg" alt="soundwave1" />
        <img src="/assets/wave.svg" alt="soundwave2" />
      </div>
      <div class="slot-duration">{{ currentSlot$ | async | hourstamp:"startTime" }} > {{ currentSlot$ | async |
        hourstamp:"endTime" }}</div>
    </div>

    <div class="play-pause-icon" [@fadeInOut]
      *ngIf="!(showEqualizer$ | async) && (isCurrentDay$ | async) && (context$ | async) !== 'SCHEDULE_WEEKLY'">
      <mwo-play-from [context]="'SCHEDULE_WEEKLY'"></mwo-play-from>
    </div>

    <div *ngIf="!(showEqualizer$ | async) && (isCurrentDay$ | async) && (context$ | async) === 'SCHEDULE_WEEKLY'"
      class="play-btn-container" [@fadeInOut]>
      <mwo-play-btn></mwo-play-btn>
    </div>
  </div>
</div>